// Accordion, form labels, tags, skeletons, links — surface + text tokens only.

export const accordionTheme = {
  baseStyle: {
    button: {
      color: 'text',
      _hover: { bg: 'surface.muted' },
      _expanded: {
        bg: 'surface.muted',
        color: 'text',
      },
    },
    panel: {
      color: 'text',
    },
  },
}

export const formLabelTheme = {
  baseStyle: {
    color: 'text.secondary',
    fontWeight: 'medium',
  },
}

export const formHelperTextTheme = {
  baseStyle: {
    color: 'text.muted',
  },
}

export const formErrorTheme = {
  baseStyle: {
    text: {
      color: 'text.danger',
    },
  },
}

export const tagTheme = {
  baseStyle: {
    container: {
      borderRadius: 'full',
    },
  },
}

export const skeletonTheme = {
  baseStyle: {
    startColor: 'skeleton.start',
    endColor: 'skeleton.end',
    speed: 1.1,
    fadeDuration: 0.6,
  },
  defaultProps: {
    startColor: 'skeleton.start',
    endColor: 'skeleton.end',
    speed: 1.1,
    fadeDuration: 0.6,
  },
}

export const spinnerTheme = {
  baseStyle: {
    color: 'accent',
    emptyColor: 'spinner.track',
  },
  defaultProps: {
    thickness: '3px',
    speed: '0.65s',
  },
}

export const progressTheme = {
  baseStyle: {
    track: {
      bg: 'spinner.track',
      borderRadius: 'md',
      overflow: 'hidden',
    },
    filledTrack: {
      bg: 'accent',
      transition: 'all 0.3s',
    },
  },
}

export const linkTheme = {
  baseStyle: {
    color: 'accent.soft',
    _hover: {
      textDecoration: 'underline',
      color: 'accent',
    },
  },
}

export const breadcrumbTheme = {
  baseStyle: {
    link: {
      color: 'text.secondary',
      _hover: { color: 'accent.soft' },
    },
  },
}

export const listTheme = {
  baseStyle: {
    container: {
      color: 'text',
    },
  },
}
